import axios from 'axios';
import { getCookie, removeCookie } from '@utils/cookies';
import { isAuthSurfacePath, unauthenticatedEntryPath } from '@utils/authEntryPaths';

const API_URL = process.env.API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = getCookie('pf_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Default Content-Type: application/json makes axios 1.x serialize FormData as JSON
  // (no multipart boundary). Multer then sees no file — e.g. "No image file provided".
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    if (config.headers && typeof config.headers.delete === 'function') {
      config.headers.delete('Content-Type');
    } else if (config.headers) {
      delete config.headers['Content-Type'];
      delete config.headers['content-type'];
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const code = error.response?.data?.code;
    // Only force-logout when the account is blocked / session revoked by moderation.
    // Generic 401s (expired token, etc.) must not clear the session automatically.
    const forcedLogout =
      (status === 403 && code === 'ACCOUNT_BLOCKED') ||
      (status === 401 && code === 'SESSION_REVOKED');
    if (forcedLogout) {
      removeCookie('pf_token');
      if (!isAuthSurfacePath(window.location.pathname)) {
        window.location.href = unauthenticatedEntryPath();
      }
    }
    return Promise.reject(error);
  }
);

export default api;
